// import React, { useState } from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import axios from "axios";
// import { CSVDownload } from "react-csv";
// import Alert from '@mui/material/Alert';

// const Navigation = () => {
//   const classes = useStyles();
//   const [isResponsive, setIsResponsive] = useState(false);
//   const [exhibitor, setExhibitor] = useState(JSON.parse(localStorage.getItem("token")).token);
//   const [csvData, setCsvData] = useState([]);
//   const [showAlert, setshowAlert] = useState(false);

//   const handleLogout = ()=>{
//         localStorage.removeItem("token");
//         // window.location.href = "/"
//   }

//   const handleToggleResponsive = () => {
//     setIsResponsive(!isResponsive);
//   };

//   const handleAlert = ()=>{
//     setshowAlert(true)
//     setTimeout(()=>{setshowAlert(false)},5000)
//   }

//   const handleDownloadCsv = async () => {
//     await axios
//       .get(
//         process.env.REACT_APP_ADMIN + "/qrCode/getAllScannedUsers?exhibitor=" + exhibitor
//       )
//       .then((data) => {
//         setCsvData(data.data)
//         console.log("Report generated")
//         // console.log(data.data)
//       })
//       .catch((error) => console.log(error));
//     return;
//   };

//   return (
//     <div className={classes.navigation}>
//     {/* {showAlert  ? <Alert severity="warning">Printer! Is that thing still around ?</Alert> : null} */}
//     {showAlert  ? <Alert severity="warning">Printer not found!</Alert> : null}
//       <div className={`${classes.menu} ${isResponsive ? classes.responsive : ''}`}>
//         {/* <a className={classes.menuLink} href="/">
//           Home
//         </a> */}
//         <a className={classes.menuLink} href="/selfcheckin">
//           Scan
//         </a>
//         {/* <a className={classes.menuLink} href="/rfid">
//           RFID
//         </a>
//         <a className={classes.menuLink} href="/rfidgenerate">
//           RFID Generate
//         </a> */}
//         <a className={classes.menuLink} href="/search">
//           Search
//         </a>
//         {/* <a className={classes.menuLink} href="/generate">
//           Generate
//         </a> */}
//         {/* don't change id as used in home  */}
//         {/* <a id="downloadReports" className={classes.menuLink} onClick={handleDownloadCsv} >
//           Reports
//           {
//            csvData.length ? <CSVDownload data={csvData} target="_blank" /> : null
//          }
//         </a> */}
//         <a className={classes.menuLink} href="/analytics">
//           Analytics
//         </a>
//         {/* <a className={classes.menuLink} onClick={handleAlert}>
//         <i className="fa fa-print">&nbsp;</i>
//         Print
//         </a> */}
//       {/* <button className={classes.menuLink} onClick={handleAlert}>
//         <i className="fa fa-print">dbd</i>
//       </button> */}
//         <a className={classes.menuLink} href="/" onClick={handleLogout}>
//             Logout
//         {/* <i className="fa fa-sign-out "></i> */}
//         </a>
//       </div>
//       <button className={classes.icon} onClick={handleToggleResponsive}>
//         <i className="fa fa-bars"></i>
//       </button>
//     </div>
//   );
// };

// const useStyles = makeStyles((theme) => ({
//     navigation: {
//       display: 'grid',
//       gridTemplateColumns: '1fr',
//       backgroundColor: '#000',
//       color: 'white',
//       height: 50,
//       [theme.breakpoints.up('sm')]: {
//         // gridTemplateColumns: '1fr 3fr',
//         height: 'auto',
//       },
//     },
//     menu: {
//       display: 'flex',
//       justifyContent: 'space-evenly',
//     //   alignItems: 'center',
//       [theme.breakpoints.down('sm')]: {
//         display: 'none',
//         flexDirection: 'column',
//         position: 'absolute',
//         color:"#870014",
//         top: 60,
//         left: "8.5%",
//         right:"8.5%",
//         backgroundColor: '#000',
//         marginBototm:100,
//         zIndex: 2,
//       },
//     },
//     menuLink: {
//       textDecoration: 'none',
//       color: 'white',
//       padding: '12px',
//       textAlign: 'center',
//       cursor:"pointer"
//     },

//     icon: {
//       display: 'none',
//       backgroundColor: '#000',
//       border: 'none',
//       color: 'white',
//       cursor: 'pointer',
//       fontSize: 24,
//       height: 50,
//       padding: '0 10px',
//       textAlign:"left",
//       [theme.breakpoints.down('sm')]: {
//         display: 'block',
//       },
//     },
//     responsive: {
//       display: 'flex',
//       flexDirection: 'column',
//     },
//   }));

// export default Navigation;

import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import refresh from "../assets/refresh-svgrepo-com.svg";
import { CSVDownload } from "react-csv";
import Alert from "@mui/material/Alert";

import homeImg from "../assets/navs/home.png";
import scanImg from "../assets/navs/qrcode.png";
import rfidImg from "../assets/navs/scanrfid2.png";
import rfidGenImg from "../assets/navs/rfidGen.png";
import exhubitorImg from "../assets/navs/exhibitor.png";
import searchImg from "../assets/navs/search.png";
import generateImg from "../assets/navs/qrcodeGen.png";
import welcomeGridImg from "../assets/navs/welcomeGrid.png";
import analyticsImg from "../assets/navs/analytics.png";
import logoutImg from "../assets/navs/logout.png";
import Logo from "../assets/checkLogo.png"

// ─── Per-image config: src + background-size scale ───────────────────────────
// scale: "100%" = normal, "120%" = 20% zoomed in, "80%" = zoomed out, etc.
const MENU_IMAGES = {
  Home:            { src: homeImg,      scale: "50%" },
  "Scan QR":            { src: scanImg,      scale: "60%" },
  RFID:            { src: rfidImg,      scale: "50%" },
  "Generate RFID": { src: rfidGenImg,   scale: "50%" },
  "Welcome Grid":   { src: welcomeGridImg,      scale: "50%" },
  Search:          { src: searchImg,    scale: "50%" },
  "Generate QR":        { src: generateImg,  scale: "50%" },
  "Add Exhibitor":       { src: exhubitorImg, scale: "50%" },
  Analytics:       { src: analyticsImg, scale: "50%" },
  Logout:          { src: logoutImg,    scale: "50%" },
};
// ─────────────────────────────────────────────────────────────────────────────

// Breakpoint at which we switch to the desktop split panel (px)
const DESKTOP_BP = 960;

const Navigation = () => {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= DESKTOP_BP : true
  );
  const [hoveredItem, setHoveredItem] = useState(null);

  const [exhibitor] = useState(JSON.parse(localStorage.getItem("token")).token);
  const [csvData, setCsvData] = useState([]);
  const [showAlert, setshowAlert] = useState(false);
  const [exhibitorName, setExhibitorName] = useState("");
  const token = JSON.parse(localStorage.getItem("token")).token;

  // ── Logged-in user's role, read once from localStorage ──
  // Requires the backend /login response to include a "role" field
  // (Exhibitor model has role: "Master" | "Session" | etc.)
  const userRole = JSON.parse(localStorage.getItem("token"))?.role;

  // Track viewport width to swap between mobile/desktop dropdown
  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= DESKTOP_BP);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Close dropdown when clicking outside
  const navRef = useRef(null);
  useEffect(() => {
    const onClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    // window.location.href = "/"
  };

  const handleToggle = () => setIsOpen((prev) => !prev);

  const handleAlert = () => {
    setshowAlert(true);
    setTimeout(() => { setshowAlert(false); }, 5000);
  };

  const handleDownloadCsv = async () => {
    await axios
      .get(process.env.REACT_APP_ADMIN + "/qrCode/getAllScannedUsers?exhibitor=" + exhibitor)
      .then((data) => {
        setCsvData(data.data);
        console.log("Report generated");
      })
      .catch((error) => console.log(error));
    return;
  };

  //  useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_ADMIN}/qrCode/checkindata?token=${token}`
  //       );
  //       const data = response.data;
  //       console.log("data",data.exhibitorDataArray[0].email);
  //       setExhibitorName(data.exhibitorDataArray[0].email);
  //     } catch (error) {
  //       console.error("Error fetching user data:", error);
  //     }
  //   };
  //   const pollData = setInterval(fetchData, 10000);
  //   fetchData();
  //   return () => { clearInterval(pollData); };
  // }, [token]);

  // ── Base menu, always visible ──
  const baseMenuItems = [
    { label: "Home",          href: "/" },
    { label: "Scan QR",          href: "/scan" },
    // { label: "RFID",          href: "/rfid" },
    { label: "Search Table",        href: "/search" },
    { label: "Generate QR",      href: "/generate" },
    // { label: "Generate RFID", href: "/rfidgenerate" },
    { label: "Welcome Grid", href: "/welcomegrid" },
    // { label: "Reports", href: "#", onClick: handleDownloadCsv },
    { label: "Analytics",     href: "/analytics" },
    // { label: "Print", onClick: handleAlert },
  ];

  // ── "Add Exhibitor" is only visible to Master role ──
  const menuItems = [
    ...baseMenuItems,
    ...(userRole === "Master"
      ? [{ label: "Add Exhibitor", href: "/exhibitors" }]
      : []),
    { label: "Logout",        href: "/", onClick: handleLogout, isLogout: true },
  ];

  return (
    <div ref={navRef} style={{ position: "relative" }}>

      {/* ════════════════════════════════════════════════
          NAVBAR BAR — always visible
      ════════════════════════════════════════════════ */}
      <div className={classes.navigation}>
        <div className={classes.navAccentLine} />

        <div className={classes.logoContainer}>
          <img
            className={classes.logo}
            // src="https://www.nyuctech.com/images/logo.png"
            src={Logo}
            alt="logo"
          />
          <h4 className={classes.exhibitorName}>{exhibitorName || ""}</h4>
        </div>

        {/* spacer — pushes icons to the right */}
        <div />

        <img
          className={classes.refreshIcon}
          onClick={() => window.location.reload()}
          src={refresh}
          width="24px"
          alt="refresh"
        />

        {/* dot grid menu button — structure & animation UNTOUCHED */}
        <button
          className={`${classes.icon} ${isOpen ? classes.rotate : ""}`}
          onClick={handleToggle}
        >
          <div className={classes.dot}></div>
          <div className={classes.dot}></div>
          <div className={classes.dot}></div>
          <div className={classes.dot}></div>
        </button>
      </div>

      {/* ════════════════════════════════════════════════
          MOBILE DROPDOWN — stacked list, ≤ DESKTOP_BP
      ════════════════════════════════════════════════ */}
      {isOpen && !isDesktop && (
        <div className={classes.mobileDropdown}>
          {menuItems.map((item, i) => (
            <a
              key={i}
              className={`${classes.mobileMenuLink} ${item.isLogout ? classes.mobileLogoutLink : ""}`}
              href={item.href}
              onClick={item.onClick}
              style={{ animationDelay: `${0.04 + i * 0.04}s` }}
            >
              <span>{item.label}</span>
            </a>
          ))}
        </div>
      )}

      {/* ════════════════════════════════════════════════
          DESKTOP SPLIT DROPDOWN — ≥ DESKTOP_BP
      ════════════════════════════════════════════════ */}
      {isOpen && isDesktop && (
        <div className={classes.desktopDropdown}>

          {/* LEFT 40% — image panel */}
          <div className={classes.imagePanel}>

            {/* Default: logo + hint */}
            <div
              className={classes.defaultLogoPanel}
              style={{ opacity: hoveredItem ? 0 : 1 }}
            >
              <img
                // src="https://www.nyuctech.com/images/logo.png"
                src={Logo}
                alt="Logo"
                className={classes.defaultLogo}
              />
              <div className={classes.defaultLogoLine} />
              <p className={classes.defaultLogoSub}>Select a section</p>
            </div>

            {/* ─── One image layer per menu item — per-image scale via background-size ─── */}
            {menuItems.map((item) => {
              // Fallback keeps this from crashing if a label doesn't
              // have a matching entry in MENU_IMAGES.
              const imgConfig = MENU_IMAGES[item.label] || { src: "", scale: "45%" };
              const isHovered = hoveredItem === item.label;
              return (
                <div
                  key={item.label}
                  className={classes.hoverImage}
                  style={{
                    opacity: isHovered ? 1 : 0,
                    backgroundImage: imgConfig.src ? `url(${imgConfig.src})` : "none",
                    // background-size drives the per-image zoom level
                    backgroundSize: isHovered ? imgConfig.scale : "45%",
                    transition: [
                      "opacity 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
                      "background-size 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
                    ].join(", "),
                  }}
                >
                  <div className={classes.hoverImageOverlay} />
                  <div className={classes.hoverImageLabel}>
                    <span className={classes.hoverImageLabelText}>{item.label}</span>
                    <div className={classes.hoverImageLabelLine} />
                  </div>
                </div>
              );
            })}
          </div>

          {/* RIGHT 60% — links */}
          <div className={classes.linksPanel}>
            {menuItems.map((item, i) => (
              <a
                key={i}
                className={`${classes.desktopLink} ${item.isLogout ? classes.desktopLogoutLink : ""}`}
                href={item.href}
                onClick={item.onClick}
                onMouseEnter={() => setHoveredItem(item.label)}
                onMouseLeave={() => setHoveredItem(null)}
                style={{ animationDelay: `${i * 0.04}s` }}
              >
                <span className={classes.desktopLinkIndex}>0{i + 1}</span>
                <span className={classes.desktopLinkLabel}>{item.label}</span>
                <span className={classes.desktopLinkArrow}>→</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  "@keyframes slideDown": {
    from: { opacity: 0, transform: "translateY(-20px)" },
    to:   { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "translateY(-50px)" },
    to:   { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes menuSlide": {
    from: { opacity: 0, transform: "translateY(-10px)" },
    to:   { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes dropdownReveal": {
    from: { opacity: 0, transform: "translateY(-10px) scaleY(0.97)", transformOrigin: "top" },
    to:   { opacity: 1, transform: "translateY(0) scaleY(1)" },
  },
  "@keyframes linkSlideIn": {
    from: { opacity: 0, transform: "translateX(16px)" },
    to:   { opacity: 1, transform: "translateX(0)" },
  },
  "@keyframes accentPulse": {
    "0%, 100%": { opacity: 0.45, transform: "scaleX(0.65)" },
    "50%":       { opacity: 1,   transform: "scaleX(1)" },
  },
  "@keyframes logoGlow": {
    "0%, 100%": { filter: "brightness(1) drop-shadow(0 0 0px rgba(232,27,35,0))" },
    "50%":       { filter: "brightness(1.1) drop-shadow(0 0 8px rgba(232,27,35,0.35))" },
  },

  /* ─── Navbar bar ─── */
  navigation: {
    display: "grid",
    gridTemplateColumns: "auto 1fr auto auto",
    alignItems: "center",
    background: "linear-gradient(90deg, #0a0a0f 0%, #111118 35%, #0e0e16 65%, #0a0a0f 100%)",
    color: "#fff",
    height: 64,
    padding: "0 24px",
    position: "relative",
    zIndex: 200,
    boxShadow: "0 1px 0 rgba(255,255,255,0.05), 0 4px 24px rgba(0,0,0,0.7), 0 6px 28px rgba(232,27,35,0.07)",
    animation: "$slideDown 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: "4%",
      right: "4%",
      height: "1px",
      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.1), rgba(232,27,35,0.25), rgba(255,255,255,0.1), transparent)",
      pointerEvents: "none",
    },
  },

  navAccentLine: {
    position: "absolute",
    bottom: 0,
    left: "8%",
    right: "8%",
    height: "2px",
    background: "linear-gradient(90deg, transparent, #e81b23, rgba(232,27,35,0.5), #e81b23, transparent)",
    borderRadius: "2px",
    animation: "$accentPulse 3s ease-in-out infinite",
    pointerEvents: "none",
    zIndex: 1,
  },

  logoContainer: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    zIndex: 5,
  },

  logo: {
    width: "250px",
    // maxWidth: "15vw",
    minWidth: "80px",
    height: "auto",
    objectFit: "contain",
    transition: "transform 0.3s ease, filter 0.4s ease",
    animation: "$logoGlow 4s ease-in-out infinite",
    "&:hover": {
      transform: "scale(1.06)",
      filter: "brightness(1.2) drop-shadow(0 0 12px rgba(232,27,35,0.5))",
    },
    "@media (max-width: 768px)": { width: "100px" },
    "@media (max-width: 480px)": { width: "80px" },
  },

  exhibitorName: {
    margin: 0,
    color: "rgba(180,180,200,0.6)",
    fontSize: "0.88rem",
    fontWeight: 500,
    letterSpacing: "0.05em",
    "@media (max-width: 480px)": { display: "none" },
  },

  refreshIcon: {
    width: "22px",
    height: "22px",
    cursor: "pointer",
    transition: "transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), filter 0.3s ease",
    filter: "brightness(0) invert(0.5)",
    marginRight: "18px",
    "&:hover": {
      transform: "rotate(200deg) scale(1.2)",
      filter: "brightness(0) invert(1) sepia(1) saturate(6) hue-rotate(320deg)",
    },
  },

  /* ── dot grid button — UNTOUCHED ── */
  icon: {
    display: "flex",
    flexWrap: "wrap",
    width: 24,
    height: 24,
    border: "none",
    background: "transparent",
    cursor: "pointer",
    transition: "transform 0.4s ease",
    justifySelf: "end",
    padding: 0,
    "&:hover": { transform: "scale(1.1)" },
  },
  dot: {
    width: 8,
    height: 8,
    backgroundColor: "rgba(190,190,210,0.65)",
    borderRadius: "50%",
    margin: 2,
    transition: "all 0.3s ease",
    boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
  },
  rotate: {
    transform: "rotate(135deg)",
    "& $dot": {
      backgroundColor: "#e81b23",
      boxShadow: "0 0 6px rgba(232,27,35,0.7)",
    },
  },

  /* ════════════════════════════════
     MOBILE DROPDOWN
  ════════════════════════════════ */
  mobileDropdown: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "absolute",
    top: 64,
    left: 0,
    right: 0,
    background: "linear-gradient(160deg, rgba(12,12,18,0.99) 0%, rgba(8,8,14,1) 100%)",
    backdropFilter: "blur(30px)",
    WebkitBackdropFilter: "blur(30px)",
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    zIndex: 198,
    borderTop: "1px solid rgba(232,27,35,0.25)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.8)",
    animation: "$fadeIn 0.22s ease-out",
    paddingBottom: 12,
  },

  mobileMenuLink: {
    textDecoration: "none",
    color: "rgba(190,190,210,0.75)",
    padding: "14px 20px",
    margin: "3px 16px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: 500,
    display: "block",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    borderRadius: "10px",
    textAlign: "center",
    width: "calc(100% - 32px)",
    animation: "$menuSlide 0.5s ease-out backwards",
    "& span": {
      position: "relative",
      display: "inline-block",
      letterSpacing: "0.03em",
    },
    "& span::after": {
      content: '""',
      position: "absolute",
      left: 0,
      bottom: -3,
      width: "100%",
      height: "2px",
      background: "linear-gradient(90deg, #e81b23 0%, rgba(232,27,35,0.4) 100%)",
      transform: "scaleX(0)",
      transformOrigin: "left",
      transition: "transform 0.3s ease",
      borderRadius: "2px",
    },
    "&:hover": {
      backgroundColor: "rgba(232,27,35,0.08)",
      color: "#fff",
      transform: "translateX(8px)",
      boxShadow: "inset 3px 0 0 #e81b23",
      "& span::after": { transform: "scaleX(1)" },
    },
  },

  mobileLogoutLink: {
    "& span": { color: "rgba(232,27,35,0.75)" },
  },

  /* ════════════════════════════════
     DESKTOP SPLIT DROPDOWN
  ════════════════════════════════ */
  desktopDropdown: {
    display: "flex",
    position: "absolute",
    top: 64,
    left: 0,
    right: 0,
    zIndex: 199,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    overflow: "hidden",
    boxShadow: "0 24px 64px rgba(0,0,0,0.85), 0 0 0 1px rgba(255,255,255,0.05)",
    animation: "$dropdownReveal 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
  },

  /* LEFT 40% — image panel */
  imagePanel: {
    position: "relative",
    width: "40%",
    minHeight: 480,
    background: "#060609",
    overflow: "hidden",
    flexShrink: 0,
  },

  defaultLogoPanel: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    transition: "opacity 0.4s ease",
    zIndex: 2,
    background: "radial-gradient(ellipse at center, rgba(232,27,35,0.07) 0%, transparent 70%)",
  },
  defaultLogo: {
    width: 250,
    opacity: 0.85,
    filter: "drop-shadow(0 0 20px rgba(232,27,35,0.3))",
  },
  defaultLogoLine: {
    width: 48,
    height: 2,
    background: "linear-gradient(90deg, transparent, #e81b23, transparent)",
    borderRadius: 2,
    margin: "4px 0",
  },
  defaultLogoSub: {
    margin: 0,
    color: "rgba(180,180,200,0.3)",
    fontSize: "0.72rem",
    letterSpacing: "0.14em",
    textTransform: "uppercase",
  },

  // NOTE: backgroundSize and transition are now set inline per-item
  // so only the static properties live here
  hoverImage: {
    position: "absolute",
    inset: 0,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    zIndex: 3,
    filter: "brightness(1.5) contrast(1.05)",
  },
  hoverImageOverlay: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(135deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.15) 60%, rgba(232,27,35,0.12) 100%)",
  },
  hoverImageLabel: {
    position: "absolute",
    bottom: 32,
    left: 32,
    right: 32,
  },
  hoverImageLabelText: {
    display: "block",
    fontSize: "2rem",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    textShadow: "0 2px 20px rgba(0,0,0,0.9)",
    lineHeight: 1,
    marginBottom: 10,
  },
  hoverImageLabelLine: {
    width: 40,
    height: 3,
    background: "#e81b23",
    borderRadius: 2,
    boxShadow: "0 0 10px rgba(232,27,35,0.7)",
  },

  /* RIGHT 60% — links panel */
  linksPanel: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "40px 56px",
    background: "linear-gradient(160deg, rgba(12,12,18,0.99) 0%, rgba(8,8,14,1) 100%)",
    backdropFilter: "blur(30px)",
    WebkitBackdropFilter: "blur(30px)",
    gap: 4,
    borderLeft: "1px solid rgba(255,255,255,0.04)",
  },

  desktopLink: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    textDecoration: "none",
    color: "rgba(190,190,210,0.65)",
    padding: "13px 20px",
    borderRadius: 12,
    cursor: "pointer",
    transition: "all 0.28s cubic-bezier(0.22, 1, 0.36, 1)",
    animation: "$linkSlideIn 0.4s cubic-bezier(0.22, 1, 0.36, 1) backwards",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      background: "linear-gradient(90deg, transparent, rgba(232,27,35,0.06), transparent)",
      transform: "translateX(-100%)",
      transition: "transform 0.4s ease",
    },
    "&:hover": {
      color: "#fff",
      backgroundColor: "rgba(232,27,35,0.07)",
      boxShadow: "inset 3px 0 0 #e81b23",
      transform: "translateX(6px)",
      "&::before": { transform: "translateX(100%)" },
      "& $desktopLinkIndex": { color: "#e81b23" },
      "& $desktopLinkArrow": { opacity: 1, transform: "translateX(0)" },
      "& $desktopLinkLabel": { color: "#fff" },
    },
  },

  desktopLinkIndex: {
    fontSize: "0.68rem",
    fontWeight: 700,
    color: "rgba(232,27,35,0.3)",
    letterSpacing: "0.08em",
    minWidth: 24,
    transition: "color 0.3s ease",
  },

  desktopLinkLabel: {
    flex: 1,
    fontSize: "1.15rem",
    fontWeight: 600,
    letterSpacing: "0.04em",
    transition: "color 0.3s ease",
  },

  desktopLinkArrow: {
    fontSize: "1rem",
    opacity: 0,
    transform: "translateX(-8px)",
    transition: "opacity 0.28s ease, transform 0.28s cubic-bezier(0.22, 1, 0.36, 1)",
    color: "#e81b23",
  },

  desktopLogoutLink: {
    marginTop: 8,
    borderTop: "1px solid rgba(232,27,35,0.1)",
    paddingTop: 16,
    "& $desktopLinkLabel": { color: "rgba(232,27,35,0.65)" },
    "&:hover": {
      "& $desktopLinkLabel": { color: "#e81b23" },
    },
  },
}));

export default Navigation;